import React from "react";
import { apiGetMediaElement } from "../../../../services/User/media"
import { getMimeTypeByFormat } from "../../../../components/Admin/Media/mediaUtils"

export default function Order(props) {
    const {id, invoiceNumber, totalTime, price, shippedDate, file} = props

    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ]

    let date = new Date(shippedDate * 1000);
    let y = date.getFullYear();
    let m = date.getMonth();
    let d = date.getDate();

    const shippedDateConvert = `${d} ${monthNames[m]}, ${y}`

    const handleDownload = (file, filename) => {
        if (file) {
            // Si inicialmente inicia con https
            if (file.startsWith("https")) {
                window.open(file, "_blank")
                return
            }
            apiGetMediaElement(file).then(resp => {
                const base64Content = resp.data?.content;
                const format = 'pdf';
                if (base64Content) {
                    const filenameIn = filename || `archivo.${format || "pdf"}`;
                    const mimeType = getMimeTypeByFormat(format);
                    const link = document.createElement("a");
                    link.href = `data:${mimeType};base64,${base64Content}`;
                    link.download = filenameIn;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
        }
    };

    return(
        <div className="card-body">

            <div>
                <div className="row">
                    <div className="col-6 col-md mb-3 mb-md-0">
                        <small className="text-dark fw-semi-bold font-weight-bold">{invoiceNumber}</small>
                    </div>

                    <div className="col-6 col-md mb-3 mb-md-0">
                        <small className="text-dark fw-semi-bold font-weight-bold">{shippedDateConvert}</small>
                    </div>

                    <div className="col-6 col-md">
                        <small className="text-dark fw-semi-bold font-weight-bold">{totalTime} m</small>
                    </div>

                    <div className="col-6 col-md">
                        <small className="text-dark fw-semi-bold font-weight-bold">{price} €</small>
                    </div>

                    <div className="col-6 col-md">
                        <small className="text-dark fw-semi-bold font-weight-bold">
                            <button
                                type="button"
                                style={{
                                    backgroundColor: '#1976d2',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '3px',
                                    padding: '2px 8px',
                                    cursor: 'pointer',
                                    fontWeight: 500,
                                    fontSize: '0.85rem',
                                    transition: 'background 0.2s',
                                }}
                                onMouseOver={e => e.currentTarget.style.backgroundColor = '#1565c0'}
                                onMouseOut={e => e.currentTarget.style.backgroundColor = '#1976d2'}
                                onClick={() => handleDownload(file, `${invoiceNumber}.pdf`)}
                            >
                                Descargar
                            </button>
                        </small>
                    </div>

                </div>
            </div>

        </div>
    )
}
